module.exports = __webpack_public_path__ + "img/sv75on.2f3882a4.svg";